module.exports = __webpack_public_path__ + "static/side-quests-de666682e5bdb530b17d6875e4069228.svg";